"use client";

import {
	Heading,
	type HeadingProps,
	RichText
} from "@pamperedchef/design-system";

import * as styles from "./TextIntro.module.scss";

export interface TextIntroProps {
	heading: HeadingProps;
	description: string;
}

/**
 * TextIntro component
 */
export function TextIntro(props: TextIntroProps): JSX.Element {
	return (
		<div className={styles["text-intro"]}>
			<Heading styledAs="h1" {...props.heading} className="mb-0" />
			<RichText
				content={props.description}
				className={styles["description"]}
			/>
		</div>
	);
}
